import { FEATURE_LINKOUT } from '../constants';
import type { FeatureConfig } from '../types';

export const linkOutFeature: FeatureConfig = {
  name: FEATURE_LINKOUT,
  toFeature({ hirerAccount }) {
    return {
      name: this.name,
      enabled: Boolean(hirerAccount?.hasLinkOutEnabled),
    };
  },
};
